import { Sanitize } from '../../Sanitize/Sanitize';
import LinkSVG from '../Components/Link.svg';

import { makeText } from '../../../util';

const Tag = ({ vendor, accordionOpen }) => (
  <a tabIndex={accordionOpen ? 0 : -1} href={vendor.policyUrl} target="_blank" className="vendor-tag linked">
    <span>{vendor.name}</span>
    <img src={LinkSVG} alt="" />
  </a>
);

export const VendorContent = ({
  vendor,
  settings,
  language,
  dev,
  accordionOpen,
}) => {
  const vendorConsent = makeText(Boolean(dev), settings, 'vendorConsent', language);

  return (
    <div className="vendor-content">
      {vendor.description && (
        <p className="pm-sub-p" dangerouslySetInnerHTML={{ __html: Sanitize({ html: vendor.description }) }} />
      )}
      {vendor.cookieHeader && (
        <div className="vendor-cookie-header">{vendor.cookieHeader}</div>
      )}
      <Tag vendor={vendor} accordionOpen={accordionOpen} /> 
      <div>
        {vendor.purposes.length > 0 && (
          <div className="vendor-info">
            <h2 className="info-title">{vendorConsent}</h2>
            {vendor.purposes.map(c => c ? <div>&#8226; {c.name || c}</div> : null)}
          </div>
        )}
      </div>

    </div>
  );
};